<template>
    <v-container>
        <h1 class="titulo mb-3">Relatório de consultas - Análise de Crédito</h1>
        <v-card class="v-card card-container">
            <v-card-text>
                <div>
                    <div id="tabs" class="container">
                        <div class="tabs">
                            <div><a @click="activetab=GROUPED_QUERIES" :class="{ active: activetab === GROUPED_QUERIES }">Consultas agrupadas</a></div>
                            <div><a @click="toDetails()" :class="{ active: activetab === DETAILED_QUERIES }">Consultas detalhadas</a></div>
                        </div>
                        <div class="content">
                            <div v-if="activetab === GROUPED_QUERIES" class="tabcontent">
                                <GroupedQueries ref="groupedQueries" @goToDetails="toDetails" />
                            </div>
                            <div v-if="activetab === DETAILED_QUERIES" class="tabcontent">
                                <DetailedQueries v-model="detailedQueriesData" />
                            </div>
                        </div>
                    </div>
                </div>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
  import GroupedQueries from '../credit-analysis/consultation-reports-components/GroupedQueries'
  import DetailedQueries from './consultation-reports-components/DetailedQueries'

  export default {
    name: 'ConsultationReports',
    components: { DetailedQueries, GroupedQueries },
    data: () => ({
      activetab: 'grouped_queries',
      detailedQueriesData: ''
    }),
    computed: {
      GROUPED_QUERIES: () => 'grouped_queries',
      DETAILED_QUERIES: () => 'detailed_queries'
    },
    methods: {
      toDetails (item = { user: [] }) {
        this.activetab = 'detailed_queries'
        this.detailedQueriesData = item
      }
    }
  }
</script>

<style scoped lang="scss">
.title-date {
    color: var(--primary);
    font-weight: 800;
}
.listagem th {
    min-width: 90px;
}
.listagem th:nth-of-type(2) {
    min-width: auto;
}
@import url('../../../assets/css/tabs.css');

</style>
